import React from 'react';
import {useSelector} from 'react-redux';
import {Col, Row, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import SpecialText from '~/components/shared/SpecialText';
import {WEIGHT_LOSS_KEYS} from '~/constants/medical-questionnaires';
import {RootState} from '~/redux/root-reducer';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire11Screen = () => {
  const {questionnaires} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.BMI_ALLERGIC);
  const questionnaireFollowingApply = questionnaires?.find(i => i.key === WEIGHT_LOSS_KEYS.FOLLOWING_APPLY);
  const currentFollowingApplyAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[WEIGHT_LOSS_KEYS.FOLLOWING_APPLY]?.data,
  );
  const filteredOptions = questionnaireFollowingApply?.options?.filter(el =>
    currentFollowingApplyAnswer?.selectedOptions?.includes(el.value),
  );

  return (
    <UiQuestionnaireLayout actions={questionnaire?.actions}>
      <Col alignItems="center" textAlign="center">
        <UiImage type="icon" name={questionnaire?.icon} boxSize={spacing.ultra} mt={spacing.medium} />
        <UiText fontSize="2xl" fontWeight="bold" mt="24px">
          {questionnaire?.questions?.default}
        </UiText>
        <UiText color="blackSecondary" fontSize="sm" mt="24px">
          {questionnaire?.questions?.sub}
        </UiText>
        <Col mt="32px" mb="26px">
          {filteredOptions?.map(option => (
            <UiText key={option.value} color="baseColor" fontSize="xs" fontWeight={700} mb="14px">
              {option.label}
            </UiText>
          ))}
        </Col>
        {questionnaire?.descriptions?.default?.map(desc => (
          <SpecialText text={desc} key={desc} />
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire11Screen;
